var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`swiper-${_vm._uid}`},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"swiper-button-prev"}),_c('div',{staticClass:"swiper-button-next"})])
}
var staticRenderFns = []

export { render, staticRenderFns }